import styled from 'styled-components';

import FilterCard from '@spa/shared/components/FilterCard';
import { mediaMin } from '@spa/shared/theme';

export const FilterContainer = styled.div`
  align-self: start;
  width: 100%;
  position: relative;
`;

export const ClearFilters = styled.button`
  color: ${props => props.theme.clearButton.color};
  background: none;
  border: none;
  padding: 0;
  position: absolute;
  top: -2px;
  right: 0;
  cursor: pointer;
  font-family: IntervalNextReg, sans-serif;
  font-size: ${props => props.theme.rem(14)};
  transition: opacity 0.25s ease-in-out;

  ${mediaMin.smallBreakpoint`
    position: initial;
    float: right;
  `}

  &.disabled {
    opacity: 0;
  }
`;

export const StickyWrapper = styled.div`
  position: relative;
  height: 70px;

  .sticky-inner {
    width: 190px;
    opacity: 0;
  }

  &.sticky {
    .sticky-inner {
      position: fixed;
      top: 80px;
      left: auto;
      right: auto;
      z-index: 1;
      opacity: 1;
      transition: opacity 1s ease-out;
    }
  }
`;

export { FilterCard };
